<template>
    <div>
        <!--<q-input filled square
                 clearable clear-icon="mdi-close"
                 type="search"
                 v-model.trim="searchText" placeholder="Search..."
                 v-on:keyup.enter="performSearch()">
            <template v-slot:append>
                <q-icon name="mdi-magnify" />
            </template>
        </q-input>

        <q-separator />-->
        <q-item-label class="text-grey-8" header>Navigation</q-item-label>
        <q-list v-for="nav of staticMenuItems" :key="nav.name">

            <q-item v-if="!nav.items"
                    :to="nav.path"
                    exact-active-class="text-bold">
                <q-item-section avatar>
                    <q-icon :name="nav.icon"></q-icon>
                </q-item-section>
                <q-item-section>
                    <q-item-label>{{ nav.name }}</q-item-label>
                </q-item-section>
            </q-item>
            <q-expansion-item v-if="nav.items"
                              :icon="nav.icon"
                              :label="nav.name"
                              expand-icon="mdi-menu-down"
                              expand-separator>
                <q-item dense
                        exact-active-class="bg-blue-grey-1"
                        v-if="nav.name == 'Support'"
                        to="/support/supporthome" exact>
                    <q-item-section avatar>
                        <q-icon name="" />
                    </q-item-section>
                    <q-item-section>
                        <q-item-label>Support Home</q-item-label>
                    </q-item-section>
                </q-item>
                <q-item dense
                        exact-active-class="bg-blue-grey-1"
                        v-for="item in nav.items" :key="item.name"
                        :to="item.path" exact>
                    <q-item-section avatar>
                        <q-icon name="" />
                    </q-item-section>
                    <q-item-section>
                        <q-item-label>{{ item.name }}</q-item-label>
                    </q-item-section>
                </q-item>
            </q-expansion-item>

        </q-list>
        <q-list v-for="nav of mobileMenuItems" :key="nav.name">

            <q-item v-if="!nav.items"
                    :to="nav.path"
                    exact-active-class="text-bold">
                <q-item-section avatar>
                    <q-icon :name="nav.icon"></q-icon>
                </q-item-section>
                <q-item-section>
                    <q-item-label>{{ nav.name }}</q-item-label>
                </q-item-section>
            </q-item>
            <q-expansion-item v-if="nav.items"
                              :icon="nav.icon"
                              :label="nav.name"
                              expand-icon="mdi-menu-down"
                              expand-separator>
                <q-item dense
                        exact-active-class="bg-blue-grey-1"
                        v-for="item in nav.items" :key="item.name"
                        :to="item.path" exact>
                    <q-item-section avatar>
                        <q-icon name="" />
                    </q-item-section>
                    <q-item-section>
                        <q-item-label>{{ item.name }}</q-item-label>
                    </q-item-section>
                </q-item>
            </q-expansion-item>

        </q-list>
        <q-separator spaced />
        <q-list>
            <q-item :to="dynamicMenuItems.cart.path"
                    exact-active-class="text-bold">
                <q-item-section avatar>
                    <q-icon :name="dynamicMenuItems.cart.icon"><q-badge color="red" floating v-if="cart.cartItems.length > 0">{{ cart.cartItems.length }}</q-badge></q-icon>
                </q-item-section>
                <q-item-section>
                    <q-item-label>{{ dynamicMenuItems.cart.name }}</q-item-label>
                </q-item-section>
            </q-item>
            <q-item v-if="isLoggedIn"
                    :to="dynamicMenuItems.myAccount.path"
                    active-class="text-bold text-primary">
                <q-item-section avatar>
                    <q-icon :name="dynamicMenuItems.myAccount.icon" />
                </q-item-section>
                <q-item-section>
                    <q-item-label>{{ dynamicMenuItems.myAccount.name }}</q-item-label>
                    <q-item-label caption lines="1">
                        {{ user.username }}
                    </q-item-label>
                </q-item-section>
            </q-item>
            <q-item v-if="isLoggedIn"
                    clickable @click="logout()"
                    active-class="text-bold text-primary">
                <q-item-section avatar>
                    <q-icon name="mdi-logout" />
                </q-item-section>
                <q-item-section>
                    <q-item-label>Sign Out</q-item-label>
                </q-item-section>
            </q-item>
            <q-item v-else
                    clickable @click="login()"
                    active-class="text-bold text-primary">
                <q-item-section avatar>
                    <q-icon name="mdi-login" />
                </q-item-section>
                <q-item-section>
                    <q-item-label>Sign In</q-item-label>
                </q-item-section>
            </q-item>
        </q-list>
    </div>
</template>
<script>
    import { colors } from 'quasar'
    import { staticMenuItems, dynamicMenuItems, mobileMenuItems } from '@/plugins/menuItems'

    export default {
        name: 'navigation-menu',
        data() {
            return {
                searchText: '',
                darkMode: false,
                staticMenuItems: staticMenuItems,
                dynamicMenuItems: dynamicMenuItems,
                mobileMenuItems: mobileMenuItems,
            }

        },
        methods: {
            logout() {
                this.$store.dispatch('logout')
                this.$router.push({ name: '/home' })
            },
            login() {
                this.$emit('login')
                //let url = '/login'
                //if (this.$route.path && this.$route.path !== url)
                //    url += '?returnUrl=' + this.$route.path
                //this.$router.push(url)
            },
            performSearch() {
                if (this.searchText)
                    this.$router.push({
                        name: '/search',
                        query: { query: this.searchText }
                    }).catch(err => { })
                this.searchText = ''
            },
        },
        computed: {
            isLoggedIn() { return this.$store.getters.isLoggedIn },
            user() { return this.$store.getters.authUser },
            cart() { return this.$store.getters.cart },
        },
        created() {
            this.darkMode = this.$store.getters.isDarkMode;
        },
        watch: {
            darkMode(newVal) {
                this.$store.commit('update_darkmode', this.darkMode)
                if (newVal) {
                    colors.setBrand('primary', '#1d8cf8')
                    colors.setBrand('secondary', '#1565c0')
                    colors.setBrand('warning', '#fb6340')
                    colors.setBrand('positive', '#42b883')
                    colors.setBrand('negative', '#ff3a60')
                    colors.setBrand('accent', '#607d8b')

                }
                else {
                    colors.setBrand('primary', '#16466f')
                    colors.setBrand('secondary', '#445c7a')
                    colors.setBrand('warning', '#ed3e16')
                    colors.setBrand('positive', '#539b3b')
                    colors.setBrand('negative', '#bd081c')
                    colors.setBrand('accent', '#0a1f30')

                }
            },
        }

    }
</script>
<style>
    .q-expansion-item--expanded > div > .q-item {
        font-weight: bold;
    }

    /* The IE11 fix involves setting a pseudo-element on the flex container with a height to match the min-height */
    .q-item:before {
        content: "";
        height: 32px;
        /* Same height as desired min-height */
    }
</style>
